"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextSection = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.ui1.mid,
    d: 'flex',
    columnGap: '4px',
    ai: 'center',
    w: '100%',
    minW: 0,
    fz: '13px',
    pd: '8px 20px',
    bxz: 'border-box',
    bd: 'none',
    mr: 0,
});
const ContextSection = ({ className, compact, bg, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const style = {
        ...rest.style,
        padding: compact ? '4px 8px' : void 0,
    };
    let element = (React.createElement("fieldset", { ...rest, style: style, className: (className || '') + blockClass({ col: styles.g(0.2) }) }));
    if (bg) {
        element = React.createElement("div", { style: { background: styles.g(0, 0.04) } }, element);
    }
    return React.createElement(React.Fragment, null, element);
};
exports.ContextSection = ContextSection;
